import { render, staticRenderFns } from "./base-pay-save.vue?vue&type=template&id=025caf45"
import script from "./base-pay-save.vue?vue&type=script&lang=js"
export * from "./base-pay-save.vue?vue&type=script&lang=js"
import style0 from "./base-pay-save.vue?vue&type=style&index=0&id=025caf45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports